<template>
  <div class="mx-1 mb-2 p-2 bg-white shadow">
    <div class="row">
      <div class="col-10 fw-bold my-auto">{{ abschnitt.textbaustein.titel }}</div>

      <div class="col-2 my-auto d-flex justify-content-end">
        <button type="button" class="btn btn-primary" @click="toggleCollapse()"><font-awesome-icon icon="magnifying-glass-plus" /></button>
      </div>
    </div>

    <div class="mt-3 pt-2 border-top border-secondary" :class="{ collapse: isCollapsed }">
      <div class="content-text">
        <div v-html="replaceVariablen(abschnitt.textbaustein.text)"></div>
      </div>

      <div v-for="subabschnitt in abschnitt.abschnitte.filter((sa) => sa.selected).sort((a, b) => a.position - b.position)" :key="subabschnitt.id" class="mt-3">
        <p v-if="subabschnitt.textbaustein.titel.length > 0" class="fw-bold text-center">{{ subabschnitt.textbaustein.titel }}</p>
        <div class="content-text">
          <div v-html="replaceVariablen(subabschnitt.textbaustein.text)"></div>

          <div
            v-for="subsubabschnitt in subabschnitt.abschnitte.filter((sa) => sa.selected).sort((a, b) => a.position - b.position)"
            :key="subsubabschnitt.id"
            class="mb-3"
          >
            <p v-if="subsubabschnitt.textbaustein.titel.length > 0" class="fw-bold">{{ subsubabschnitt.textbaustein.titel }}</p>
            <div class="content-text">
              <div v-html="replaceVariablen(subsubabschnitt.textbaustein.text)"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { PropType, ref, computed } from 'vue';
  import { useStore } from '@/store';
  import { Input, TextAbschnitt } from '@/models/VertragModels';

  const props = defineProps({
    abschnitt: {
      type: Object as PropType<TextAbschnitt>,
      required: true,
    },
    inputs: {
      type: Object as PropType<Array<Input>>,
      default: new Array<Input>(),
    },
  });

  const store = useStore();
  const authUser = computed(() => store.getters.authUser);

  function replaceVariablen(text: string) {
    let replacedText = text;

    const variableRegex = /&lt;&lt;([^&]+)&gt;&gt;/g;

    let match;
    while ((match = variableRegex.exec(text)) !== null) {
      const variablePlatzhalter = `<<${match[1].toString()}>>`;
      const input = props.inputs.find((i) => i.variable.platzhalter === variablePlatzhalter);

      // Datum Variable "today"
      if (input && input.value != undefined && input.variable.type === 'date' && input.variable.validationType === 'today') {
        replacedText = replacedText.replace(
          match[0],
          new Date().toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'Europe/Berlin' })
        );
      }

      // Datum Variable (formatieren)
      else if (input && input.value != undefined && input.variable.type === 'date') {
        replacedText = replacedText.replace(
          match[0],
          new Date(input.value).toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'Europe/Berlin' })
        );
      }

      // Allgemeine Variable
      else if (input && input.value != undefined && input.value !== '') {
        replacedText = replacedText.replace(match[0], input.value);
      }

      // Benutzersignatur, wenn kein Default gesetzt
      else if (input && input.value != undefined && input.value === '' && input.variable.validationType === 'usersignature' && authUser.value?.canSign) {
        const signatureName = authUser.value?.name != '' ? authUser.value?.name : authUser.value?.benutzername || '';
        replacedText = replacedText.replace(match[0], signatureName);
      }

      // Unbekannte Variable oder Variablen Value nicht gesetzt
      else {
        replacedText = replacedText.replace(match[0], `<span style="background: yellow">${match[0]}</span>`);
      }
    }

    return replacedText;
  }

  const isCollapsed = ref(true);
  function toggleCollapse() {
    isCollapsed.value = !isCollapsed.value;
  }
</script>
